/**
 * Rôles internes de la plateforme, repris du cahier des charges CNSS
 * (PRD §6, Architecture §3.4, Modules §MODULE 6, Parcours utilisateurs §1).
 *
 * IMPORTANT — périmètre : `AGENT_IMMATRICULATION` est conservé dans l'énumération
 * pour compatibilité future avec le système CNSS, mais n'est **pas** attribuable
 * ni actif dans cette plateforme : la création du dossier d'immatriculation reste
 * hors périmètre (voir docs/cutover-cnss-sync.md).
 */
export const ROLE_CODES = [
    'SUPER_ADMIN',
    'ADMIN_NATIONAL',
    'ADMIN_PROVINCIAL',
    'SUPERVISEUR_AGENCE',
    'AGENT_DOCUMENTAIRE',
    'AGENT_BIOMETRIQUE',
    'AGENT_CARTE',
    'AGENT_LOGISTIQUE',
    'AGENT_REMISE',
    'AGENT_CONTROLE',
    'AUDITEUR',
    'AGENT_IMMATRICULATION',
];
/** Rôles qu'un administrateur peut assigner à un compte dans cette version du logiciel. */
export const ASSIGNABLE_ROLE_CODES = ROLE_CODES.filter((r) => r !== 'AGENT_IMMATRICULATION');
export const ROLE_LABELS = {
    SUPER_ADMIN: 'Super administrateur',
    ADMIN_NATIONAL: 'Administrateur national',
    ADMIN_PROVINCIAL: 'Administrateur provincial',
    SUPERVISEUR_AGENCE: "Superviseur d'agence",
    AGENT_DOCUMENTAIRE: 'Agent de contrôle documentaire',
    AGENT_BIOMETRIQUE: 'Agent biométrique',
    AGENT_CARTE: 'Agent de personnalisation / gestion carte',
    AGENT_LOGISTIQUE: 'Agent logistique',
    AGENT_REMISE: 'Agent de remise de carte',
    AGENT_CONTROLE: 'Agent de contrôle / vérification',
    AUDITEUR: 'Auditeur / contrôle interne',
    AGENT_IMMATRICULATION: "Agent d'immatriculation (réservé — hors périmètre)",
};
/** Rôles pour lesquels la double authentification (TOTP) est obligatoire à la connexion. */
export const ROLES_REQUIRING_2FA = [
    'SUPER_ADMIN',
    'ADMIN_NATIONAL',
    'ADMIN_PROVINCIAL',
    'SUPERVISEUR_AGENCE',
    'AUDITEUR',
];
//# sourceMappingURL=roles.js.map